import {twMerge} from "tailwind-merge";
import {useRef, useState} from "react";
import Link from "next/link";
import {fetchData, isEmpty} from "@/utils/global-functions";
import {REQ_TYPES} from "@/constants/general-constants";
import {useRouter} from 'next/navigation';

export default function SearchInput({
                                        url = "",
                                        submitClasses = "",
                                        parentClasses = "",
                                        inputClasses = "",
                                        ...otherProps
                                    }) {

    const [searchValue, setSearchValue] = useState("");
    const [searchBox, setSearchBox] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const searchInputRef = useRef(null);
    const router = useRouter()

    const onSearchChange = async ({target: {value}}) => {
        setSearchValue(value);
        if (value.length >= 3) {
            const searchData = await fetchData("blog/search-suggest", REQ_TYPES.GET, {search: value});
            if (!searchData.error) {
                const results = !isEmpty(searchData.data) ? searchData.data.data : {};
                setSuggestions(!isEmpty(results) ? results.data : [])
            }
        }
    }

    const showSearchBoxHandler = (status) => {
        setSearchBox(status);
        if (!status) {
            setSearchValue("");
            searchInputRef.current.blur();
        }
    }

    const onSearch = (e) => {
        e.preventDefault();
        showSearchBoxHandler(false);
        router.push(`/blog?search=${searchValue}`);
    }

    return (
        <div className={twMerge("relative", parentClasses)}>
            <div className={`fixed top-0 left-0 w-screen h-screen z-40 ${searchBox ? "" : "hidden"}`}
                 onClick={() => showSearchBoxHandler(false)}/>
            <form className="relative z-50" onSubmit={onSearch}>
                <div
                    className={`absolute top-16 z-50 rounded-2xl w-full bg-white border border-pol-light min-h-[14.063rem] shadow-[0_0_9px_11px_rgba(142,130,180,0.06)] flex flex-col px-2 py-5 ${searchBox ? "" : "hidden"}`}>
                    {
                        searchValue.length < 3 ?
                            <p className="my-auto text-center">برای جستجو حداقل ۳ حرف وارد کنید</p> :
                            <>
                                {
                                    suggestions.length ?
                                        suggestions.map(result => (
                                            <div key={result.slug}
                                                 className="px-2.5 truncate max-w-full py-5 text-pol-dark-800 rounded-lg hover:bg-pol-light hover:text-pol-blue">
                                                <Link onClick={() => showSearchBoxHandler(false)}
                                                      className="font-semibold"
                                                      href={`/blog/${result.slug}`}>{result.title}</Link>
                                            </div>
                                        )) : <p className="my-auto text-center">مقاله ی مرتبطی پیدا نشد</p>
                                }
                            </>
                    }
                </div>
                <input
                    type="search"
                    ref={searchInputRef}
                    onFocus={() => showSearchBoxHandler(true)}
                    onChange={onSearchChange}
                    value={searchValue}
                    className={twMerge("relative py-[0.97rem] pl-14 pr-[1.125rem] w-full lg:w-[18.313rem] rounded-[0.875rem] outline-1 outline outline-white/[0.12] placeholder:text-white text-white", inputClasses)}
                    style={{background: "linear-gradient(135deg, rgba(255,255,255,0.11) 0%, rgba(255,255,255,0.06) 75%)"}}
                    {...otherProps}
                />
                <button
                    className="absolute bg-pol-gray-600 top-1.5 left-[0.313rem] z-10 rounded-[0.625rem] w-[2.688rem] h-[2.688rem] flex-center"
                    aria-label="Search"
                    type="submit">
                    <i className="icon-search text-pol-light"/>
                </button>
            </form>
        </div>
    )
}
